export function readUtmFromLocation(search) {
  const params = new URLSearchParams(search || "");
  const keys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_id",
  ];
  const utm = {};

  let hasAny = false;

  for (const k of keys) {
    const v = params.get(k);
    if (v != null && String(v).trim().length > 0) {
      utm[k] = String(v).trim();
      hasAny = true;
    }
  }

  return hasAny ? utm : null;
}

export function saveUtmToSession(utm) {
  if (typeof window === "undefined") return;
  if (!utm) return;

  try {
    window.sessionStorage.setItem("dc_utm", JSON.stringify(utm));
  } catch {}
}

export function getUtmFromSession() {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.sessionStorage.getItem("dc_utm");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}
